export default __webpack_public_path__ + "static/media/KML.750f1b5d.png";